import { BaseModel, convertToModel, registerModel } from '~/shared/model'
import { isArray, isUnknownObject } from '~/shared/utils/guards'
import LandingSettings from './LandingSettings'
import LandingMainBannerBlock from './LandingMainBannerBlock'
import LandingRectangularBannerBlock from './LandingRectangularBannerBlock'
import LandingTextBlock from './LandingTextBlock'
import LandingTextImageBlock from './LandingTextImageBlock'
import LandingImagesBlock from './LandingImagesBlock'
import LandingAdvantagesBlock from './LandingAdvantagesBlock'
import LandingImageBlock from './LandingImageBlock'
import LandingVideoBlock from './LandingVideoBlock'
import LandingFeedbackBlock from './LandingFeedbackBlock'
import type { LandingBlock } from './types'

export default class Landing extends BaseModel {
  static override constructorName = 'Landing'

  content: LandingBlock[] = []
  settings: LandingSettings = new LandingSettings()

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      this.content = isArray(data.content)
        ? data.content.map(toBlock).filter(block => block !== null)
        : []
      this.settings = convertToModel(data.settings, LandingSettings, new LandingSettings())
    }
  }
}

function toBlock(block: unknown): LandingBlock | null {
  if (!isUnknownObject(block)) return null

  if (block.name === 'advantages_block') return new LandingAdvantagesBlock(block)
  if (block.name === 'images_block') return new LandingImagesBlock(block)
  if (block.name === 'video_block') return new LandingVideoBlock(block)
  if (block.name === 'text_block') return new LandingTextBlock(block)
  if (block.name === 'image_block') return new LandingImageBlock(block)
  if (block.name === 'main_banner_block') return new LandingMainBannerBlock(block)
  if (block.name === 'text_and_image_block') return new LandingTextImageBlock(block)
  if (block.name === 'feedback_block') return new LandingFeedbackBlock(block)
  if (block.name === 'rectangular_banner_block') return new LandingRectangularBannerBlock(block)

  return null
}

registerModel(Landing)
